import { useCallback } from 'react';
import { useBrand } from './BrandProvider';
import type { BrandKey } from './types';

/**
 * Vocabulário da marca nas UIs (inscrição → compra, paróquia → empresa).
 * Não altera URL, API nem e-mail.
 */
export function brandRegistrationCopy(
  text: string,
  brandKey: BrandKey | string | null | undefined
): string {
  if (brandKey !== 'zuadaria') return text;
  return text
    .replace(/Inscrições/g, 'Compras')
    .replace(/inscrições/g, 'compras')
    .replace(/INSCRIÇÕES/g, 'COMPRAS')
    .replace(/Inscrição/g, 'Compra')
    .replace(/inscrição/g, 'compra')
    .replace(/INSCRIÇÃO/g, 'COMPRA')
    .replace(/Subparóquias/g, '\0SUBS\0')
    .replace(/subparóquias/g, '\0subs\0')
    .replace(/Subparóquia/g, '\0SUB\0')
    .replace(/subparóquia/g, '\0sub\0')
    .replace(/Paróquias/g, 'Empresas')
    .replace(/paróquias/g, 'empresas')
    .replace(/Paróquia/g, 'Empresa')
    .replace(/paróquia/g, 'empresa')
    .replace(/\0SUBS\0/g, 'Subparóquias')
    .replace(/\0subs\0/g, 'subparóquias')
    .replace(/\0SUB\0/g, 'Subparóquia')
    .replace(/\0sub\0/g, 'subparóquia');
}

export function useBrandRegistrationCopy(): (text: string) => string {
  const brand = useBrand();
  return useCallback((text: string) => brandRegistrationCopy(text, brand.key), [brand.key]);
}
